var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "md-layout" }, [
      _c("div", { staticClass: "md-layout-item " }, [
        _c("div", { staticClass: "custom-toolbar" }, [
          _c(
            "div",
            { staticClass: "custom-toolbar-start" },
            [
              _c("BillingAccountsFilter", {
                on: { onChanged: _vm.billingAccountsFilterChangedHandler },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "custom-toolbar-end" },
            [
              _vm.$root.isDesktop
                ? _c("SearchComponent", {
                    attrs: {
                      "search-filter": _vm.searchText,
                      placeholder: _vm.searchPlaceholder,
                    },
                    on: { onSearch: _vm.searchComponentSearchHandler },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "md-layout" }, [
      _c(
        "div",
        {
          staticClass:
            "md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100",
        },
        [
          _c(
            "md-card",
            [
              _c(
                "md-card-header",
                { staticClass: "md-card-header-icon md-card-header-blue" },
                [
                  _c(
                    "div",
                    { staticClass: "card-icon" },
                    [_c("md-icon", [_vm._v("payment")])],
                    1
                  ),
                ]
              ),
              _c("md-card-content", [
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    !_vm.searchResults || !_vm.searchResults.length
                      ? [_c("p", [_vm._v("No result found.")])]
                      : [
                          _c(
                            "div",
                            { staticClass: "column" },
                            [
                              _c(
                                "md-table",
                                [
                                  _c(
                                    "md-table-row",
                                    [
                                      _c("md-table-head", [_vm._v(" ")]),
                                      _c("md-table-head", [_vm._v("Company")]),
                                      _c("md-table-head", [
                                        _vm._v("Team Status"),
                                      ]),
                                      _c("md-table-head", [
                                        _vm._v("Billing Status"),
                                      ]),
                                      _c("md-table-head", [
                                        _vm._v("Free Users Allowed"),
                                      ]),
                                      _c("md-table-head", [
                                        _vm._v("Active User"),
                                      ]),
                                      _c("md-table-head", [
                                        _vm._v("Licensed User"),
                                      ]),
                                      _c("md-table-head", [_vm._v(" ")]),
                                    ],
                                    1
                                  ),
                                  _vm._l(
                                    _vm.searchResults,
                                    function (item, itemIndex) {
                                      return _c(
                                        "md-table-row",
                                        { key: "result-" + itemIndex },
                                        [
                                          _c("md-table-cell", [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  ++itemIndex +
                                                    (_vm.pagination
                                                      .currentPage -
                                                      1) *
                                                      _vm.pagination.perPage
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]),
                                          _c("md-table-cell", [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(item.company) +
                                                "\n                                        "
                                            ),
                                          ]),
                                          _c("md-table-cell", [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(item.teamStatus) +
                                                "\n                                        "
                                            ),
                                          ]),
                                          _c(
                                            "md-table-cell",
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(item.billingStatus) +
                                                  "\n                                            "
                                              ),
                                              item.billingStatus === "free"
                                                ? [
                                                    _c("br"),
                                                    item.freeUntilDate
                                                      ? _c("i", [
                                                          _c("span", [
                                                            _vm._v(
                                                              "\n                                                        until\n                                                        " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "dateFormat"
                                                                  )(
                                                                    item.freeUntilDate,
                                                                    _vm
                                                                      .DATE_TYPES
                                                                      .internationalDate
                                                                  )
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                          ]),
                                                        ])
                                                      : _vm._e(),
                                                  ]
                                                : _vm._e(),
                                            ],
                                            2
                                          ),
                                          _c("md-table-cell", [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  item.billingStatus ===
                                                    "free" &&
                                                    item.freeUsersAllowed
                                                    ? item.freeUsersAllowed
                                                    : "-"
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]),
                                          _c("md-table-cell", [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(item.activeUsers) +
                                                "\n                                        "
                                            ),
                                          ]),
                                          _c("md-table-cell", [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  item.licensedUsers
                                                    ? item.licensedUsers
                                                    : "-"
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]),
                                          _c(
                                            "md-table-cell",
                                            [
                                              _c(
                                                "md-button",
                                                {
                                                  staticClass:
                                                    "md-info md-just-icon md-round md-primary",
                                                  attrs: {
                                                    title: "Change Status",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.openChangeStatus(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("md-icon", [
                                                    _vm._v("flip"),
                                                  ]),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "md-button",
                                                {
                                                  staticClass:
                                                    "md-info md-just-icon md-round md-primary",
                                                  attrs: {
                                                    title: "Set as free",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.openSetAsFree(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("md-icon", [
                                                    _vm._v("money_off_csred"),
                                                  ]),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "md-button",
                                                {
                                                  staticClass:
                                                    "md-info md-just-icon md-round md-primary",
                                                  attrs: {
                                                    title: "Update pricing",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.openPricing(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("md-icon", [
                                                    _vm._v("price_change"),
                                                  ]),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "md-button",
                                                {
                                                  staticClass:
                                                    "md-info md-just-icon md-round md-primary",
                                                  attrs: {
                                                    title: "View Details",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.openDetails(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("md-icon", [
                                                    _vm._v("payment"),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                  ],
                  2
                ),
              ]),
              _vm.total
                ? _c(
                    "md-card-actions",
                    {
                      staticClass: "page-footer",
                      attrs: { "md-alignment": "space-between" },
                    },
                    [
                      _c("div", [
                        _vm.total === _vm.pagination.perPage
                          ? _c("p", { staticClass: "card-category" }, [
                              _vm._v(
                                "\n                            Page " +
                                  _vm._s(_vm.pagination.currentPage) +
                                  " of many\n                        "
                              ),
                            ])
                          : _c("p", { staticClass: "card-category" }, [
                              _vm._v(
                                "Page " +
                                  _vm._s(_vm.pagination.currentPage) +
                                  " of " +
                                  _vm._s(_vm.totalPages)
                              ),
                            ]),
                      ]),
                      _c("Pagination", {
                        staticClass: "pagination-no-border pagination-success",
                        attrs: {
                          "per-page": _vm.pagination.perPage,
                          total: _vm.total,
                          "enable-first-page-link": true,
                          "enable-last-page-link": true,
                        },
                        on: {
                          "change-page": function ($event) {
                            return _vm.handleChangePage(
                              $event,
                              _vm.pagination.perPage
                            )
                          },
                        },
                        model: {
                          value: _vm.pagination.currentPage,
                          callback: function ($$v) {
                            _vm.$set(_vm.pagination, "currentPage", $$v)
                          },
                          expression: "pagination.currentPage",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }